export const environment = {
  production: false,
  identityApi: `https://identity.performa365.com`,
  reportsApi: `https://reports-api.performa365.com`,
  helpUrl: `https://performa365-report.readthedocs.io`,
  examApi: `#{examApiUrl}`
};
